/**
 * Nombres/fragmentos usados para detectar si un indicador `dsl_*` es un oscilador
 * (va en un panel aparte) o un overlay (se dibuja sobre las velas).
 * Compartido entre grafica-modelo y multicharts-dialog — antes estaba duplicado
 * literalmente en ambos componentes.
 */
export const OSCILLATORS: string[] = [
  'OBV', 'Percent_Return', 'SSF', 'CCI', 'KST', 'Fisher', 'RVGI', 'CDL_Pattern',
  'Squeeze_Pro', 'Quantile', 'CTI', 'TRIX', 'APO', 'STC', 'LinReg', 'Chop', 'PVO',
  'Slope', 'AO', 'KDJ', 'Aroon', 'Skew', 'CMO', 'QQE', 'RSI', 'StochRSI', 'Stochastic',
  'UO', 'StDev', 'ER', 'BRAR', 'Entropy', 'RSX', 'PGO', 'ERI', 'Williams_%R', 'PPO',
  'AMAT', 'Log_Return', 'TSI', 'Squeeze', 'CDL_Z', 'MACD', 'ROC', 'PSL', 'SWMA',
  'EBSW', 'Momentum', 'Variance', 'Coppock', 'TD_SEQ', 'Volume', 'volume', 'ADX',
  'BOP', 'MCGD', 'ATR', 'vol: historica', 'vol: relativa', 'vol', 'vol:_historica',
  '#vol:_historica', 'vol:_relativa',
];
